export default __webpack_public_path__ + "static/media/Rubik-Black.2b561a8e.ttf";